import Button from 'components/Button'
import ButtonPrimary from 'components/ButtonPrimary'
import ContentBox from 'components/ContentBox'
import OrderActions from 'components/OrderActions'
import StaticPopup from 'components/StaticPopup'
import { View } from 'components/View'
import appMessages from 'messages/app'
import {
  getShippingLabelOrderUtil,
  hasShippingLabelOrderUtil
} from 'models/daos/order/utils/get-shipping-label'
import { isInPreparationOrderUtil } from 'models/daos/order/utils/get-status'
import { isCancellableOrderUtil } from 'models/daos/order/utils'
import { cancelOrderAction } from 'modules/orders/actions/cancel'
import { getShippingLabelOrderAction } from 'modules/orders/actions/get-shipping-label'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import { isAdminUserSelector } from 'modules/users/selectors/is-admin'
import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages } from 'react-intl'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import WithIntl from 'components/WithIntl'
import { capitalizeStringUtil } from 'packages/src'

const messages = defineMessages({
  title: {
    id: 'OrderActionsContainer.title',
    defaultMessage: 'Order Actions'
  }
})

class OrderActionsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.handleClickGetShippingLabel = this.handleClickGetShippingLabel.bind(this)
    this.handleClickShowShippingLabel = this.handleClickShowShippingLabel.bind(this)
    this.handleClickCancel = this.handleClickCancel.bind(this)
  }

  handleClickCancel () {
    this.props.dispatch(
      cancelOrderAction(this.props.instance)
    )
  }

  handleClickGetShippingLabel () {
    this.props.dispatch(
      getShippingLabelOrderAction(this.props.instance)
    )
  }

  handleClickShowShippingLabel () {
    new StaticPopup({ // eslint-disable-line
      title: 'Shipping Label',
      url: getShippingLabelOrderUtil(this.props.instance)
    })
  }

  isCancellable () {
    return isCancellableOrderUtil(this.props.instance)
  }

  renderCancel () {
    if (!this.isCancellable()) {
      return
    }
    return (
      <Button onClick={this.handleClickCancel}>
        {
          capitalizeStringUtil(
            this.props.intl.formatMessage(appMessages.cancel)
          )
        }
      </Button>
    )
  }

  renderGetShippingLabel () {
    const { instance } = this.props
    if (
      hasShippingLabelOrderUtil(instance) ||
      !this.props.isUserAdmin ||
      !isInPreparationOrderUtil(instance)
    ) {
      return
    }
    return (
      <ButtonPrimary onClick={this.handleClickGetShippingLabel}>
        Get Shipping Label
      </ButtonPrimary>
    )
  }

  renderShowShippingLabel () {
    const { instance } = this.props
    if (
      !hasShippingLabelOrderUtil(instance) ||
      !this.props.isUserAdmin
    ) {
      return
    }
    return (
      <ButtonPrimary onClick={this.handleClickShowShippingLabel}>
        Show Shipping Label
      </ButtonPrimary>
    )
  }

  renderTitle () {
    return (
      <OrderActions.Title
        value={(
          this.props.intl.formatMessage(
            messages.title
          )
        )}
      />
    )
  }

  render () {
    if (!this.isCancellable() && !this.props.isUserAdmin) {
      return React.Fragment
    }
    return (
      <section>
        <ContentBox>
          <View
            style={{
              alignItems: View.ALIGN.CENTER
            }}
          >
            {this.renderTitle()}
            {this.renderGetShippingLabel()}
            {this.renderShowShippingLabel()}
            {this.renderCancel()}
          </View>
        </ContentBox>
      </section>
    )
  }
}

OrderActionsContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  instance: PropTypes.object,
  isUserAdmin: PropTypes.bool,
  intl: PropTypes.object.isRequired
}

const select = () => createSelector(
  isAdminUserSelector(),
  getInstanceSectionSelector(),
  (isUserAdmin, instance) => ({
    isUserAdmin,
    instance
  })
)

export default WithIntl(
  connect(select)(OrderActionsContainer)
)
